import { proxy, useSnapshot } from '@workwave-tidal/core/valtio'

const store = proxy({
  tidalThemeActive: false,
})

export function setTidalThemeActive(active: boolean) {
  store.tidalThemeActive = active
}

export function toggleTidalThemeActive() {
  store.tidalThemeActive = !store.tidalThemeActive
}

export function useTidalThemeActive() {
  return useSnapshot(store).tidalThemeActive
}
